import API from "./apiConfig";
import { APIFormData } from "./apiConfig";
export default {

    getAdmissionData(page, rowsPerPage) {
        return API.get(`/getAdmissionData?page=${page}&per_page=${rowsPerPage}`);
    },
    getBrochure() {
        return API.get('/getBrochure');
    },
    saveRemark(id, text) {
        return API.post('saveRemark', { id, text });
    },
    saveSchool(data) {
        return API.post('saveSchool', { data });
    },
    getSchools() {
        return API.get('getSchools');
    },
    getCourses(id) {
        return API.get(`getCourses/${id}`);
    },
    getAllCourse() {
        return API.get(`getAllCourse`);
    },
    getStudents() {
        return API.get('getStudents');
    },
    deleteStudent(data){
        return API.post('deleteStudent' ,{data})
    },
    searchStudent(data) {
        return API.post('searchStudent', { data });
    },
    getAlumni(data) {
        return API.post('getAlumni', { data });
    },
    getSchoolData(slug) {
        return API.get(`getSchoolData/${slug}`);
    },
    getCourseDetails(name) {
        return API.get(`getCourseDetails/${name}`);
    },

    getEvents() {
        return API.get('getEvents');
    },
    changeEventStatus(id, status) {
        return API.post('changeEventStatus', { id, status });
    },
    changeBlogStatus(id, status) {
        return API.post('changeBlogStatus', { id, status });
    },
    changeNoticeStatus(id, status) {
        return API.post('changeNoticeStatus', { id, status });
    },
    getEventAndNotice() {
        return API.get('getEventAndNotice');
    },
    getRecruiter() {
        return API.get('getRecruiter');
    },
    getStudentsWithCourse(data) {
        return API.post('getStudentsWithCourse', { data });
    },
    getBlogs() {
        return API.get('getBlogs');
    },

    singleBlog(id) {
        return API.get(`singleBlog/${id}`);
    },

    sendMailToStudent(msg, data) {
        return API.post('sendMailToStudent', { msg, data });
    },
    downloadBrochure(data) {
        return API.post('downloadBrochure', { data });
    },
    getCareer() {
        return API.get('getCareer');
    },
    saveCareer(data) {
        return API.post('saveCareer', { data });
    },
    changeCareerStatus(id, status) {
        return API.post('changeCareerStatus', { id, status });
    },
    changeRecruiterStatus(id, status) {
        return API.post('changeRecruiterStatus', { id, status });
    },

    getFaculty(id) {
        return API.get(`getFaculty/${id}`);
    },
    deleteFaculty(id){
        return API.post('deleteFaculty', {id})
    },

    savePublication(data) {
        return API.post(`savePublication`, { data })
    },
    getPublications() {
        return API.get('getPublications');
    },
    getPublicationByFaculty(data) {
        return API.post('getPublicationByFaculty', { data })
    },

    resumeUpload(data) {
        return API.post('resumeUpload', { data })
    },
    getResumes() {
        return API.get('getResumes')
    },

    studentStatus(data) {
        return API.post('studentStatus', { data })
    },

    count() {
        return API.get('count');
    },
    getAffiliations() {
        return API.get('getAffiliations');
    },
    saveAffiliation(data) {
        return API.post('saveAffiliation', { data })
    },
    saveAchievement(data) {
        return API.post('saveAchievement', data)
    },
    getAchievment() {
        return API.get('getAchievment');
    },
    deleteAchivement(data){
        return API.post('deleteAchivement' ,{data})
    },
    checkStudent(login) {
        return API.post('checkStudent', {login})
    },
    approveStudent(data) {
        return API.post('approveStudent', {data})
    },
    approveAlumni(data) {
        return API.post('approveAlumni', {data})
    },
    getRagging(){
        return API.get('getRagging')
    },
    approveBlog(id) {
        return API.post('approveBlog', {id})
    },
    fetchGallery(page, rowsPerPage){
        return API.get(`gallery?page=${page}&per_page=${rowsPerPage}`)
    },
    addGalleryImage(data){
        return APIFormData.post('/gallery',data)
    },
    deleteGalleryImage(id){
        return API.delete(`/gallery/${id}`)
    },
    // login 
    register(formData) {
        return API.post('/register', { formData });
    },

    login(email, password) {
        return API.post('/login', { email, password })
    }




}